import { render, staticRenderFns } from "./MoneyInput.vue?vue&type=template&id=024b33b0&"
import script from "./MoneyInput.vue?vue&type=script&lang=js&"
export * from "./MoneyInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\takaj\\Documents\\COFOUNDRY\\okinus-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('024b33b0')) {
      api.createRecord('024b33b0', component.options)
    } else {
      api.reload('024b33b0', component.options)
    }
    module.hot.accept("./MoneyInput.vue?vue&type=template&id=024b33b0&", function () {
      api.rerender('024b33b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/fndry-vue/packages/fn-types/inputs/MoneyInput.vue"
export default component.exports